module.exports = __webpack_public_path__ + "assets/img/WhatsApp.2f38bb66.svg";